import { CREIGHTON_DATA } from "./creighton/creighton"
import { SIENA_DATA } from "./siena"
import { TWO_OCEAN_DATA } from "./twoOcean/two_ocean"
import { VANGUARD_DATA } from "./vanguard/vanguard"
import { HOLLINS_DATA } from "./hollins/hollins"

export const COLLEGES = [
  {
    data: SIENA_DATA,
    tealiumProfile: process.env.REACT_APP_TEALIUM_SIENA_PROFILE,
    collegeId: process.env.REACT_APP_SIENA_CID,
  },
  {
    data: CREIGHTON_DATA,
    tealiumProfile: process.env.REACT_APP_TEALIUM_CREIGHTON_PROFILE,
    collegeId: process.env.REACT_APP_CREIGHTON_CID,
  },
  {
    data: TWO_OCEAN_DATA,
    tealiumProfile: process.env.REACT_APP_TEALIUM_TWO_OCEAN_PROFILE,
    collegeId: process.env.REACT_APP_TWO_OCEAN_CID,
  },
  {
    data: VANGUARD_DATA,
    tealiumProfile: process.env.REACT_APP_TEALIUM_VANGUARD_PROFILE,
    collegeId: process.env.REACT_APP_VANGUARD_CID,
  },
  {
    data: HOLLINS_DATA,
    tealiumProfile: process.env.REACT_APP_TEALIUM_HOLLINS_PROFILE,
    collegeId: process.env.REACT_APP_HOLLINS_CID,
    currentlyActive: true,
  },
]

export const TEST_DATA = TWO_OCEAN_DATA

//keys to transform plain object to object with nested structures
export const COLLEGE_NESTED_FIELDS = {
  siena: ["parent", "alumni", "institution", "course"],
  vanguard: ["parent", "alumni"],
  creighton: ["parent", "alumni", "sibling", "extracurricular", "institution"],
  hollins: ["parent", "sibling", "alumni"],
}

//keys to transform from nested structures to plain object
export const COLLEGE_NESTED_FIELDS_TO_PLAIN_OBJECT = {
  siena: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
    { key: "institution_attended", dependencyKey: "institutions" },
    { key: "course_taken", dependencyKey: "courses" },
  ],
  vanguard: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
  ],
  creighton: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
    { key: "institution_attended", dependencyKey: "institutions" },
    { key: "sibling_existence", dependencyKey: "siblings" },
    {
      key: "extracurricular_activity_taken",
      dependencyKey: "extracurriculars",
    },
  ],
  hollins: [
    { key: "parent_existence", dependencyKey: "parents" },
    { key: "alumni_shared", dependencyKey: "alumnis" },
    { key: "sibling_existence", dependencyKey: "siblings" },
  ],
}
